import { useMutation } from 'react-query'
import { Navigate, useLocation, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { ManagementAddNewLoanValidate } from 'services/loans/manager'
import posthog from 'posthog-js'

export default function useValidateInstallments() {
    const navigate = useNavigate()
    const { state } = useLocation()
    const { isLoading, mutate } = useMutation({
        mutationFn: (payload: IManagementBodyValidate) => {
            return ManagementAddNewLoanValidate(payload)
        },
        onSuccess: (data, variables: any) => {
            if (data.is_valid) {
                posthog.capture('old_loan_register_step_completed', {
                    step: 'installments',
                    fund_id:
                        (variables as any)?.moneyPool ??
                        (state as any)?.payload?.moneyPool,
                })
                navigate('/loans/add-old/management/final/add', {
                    state: { ...state },
                })
            } else {
                posthog.capture('old_loan_register_failed', {
                    step: 'installments',
                    reason: 'validation',
                    fund_id:
                        (variables as any)?.moneyPool ??
                        (state as any)?.payload?.moneyPool,
                })
                if (data.amount_errors.length > 0) {
                    toast.error('مقدار وارد شده برای قسط ها اشتباه است')
                }
                if (data.due_date_errors.length > 0) {
                    toast.error('تاریخ وارد شده برای قسط ها اشتباه است')
                }
            }
        },
        onError: (error: any, variables: any) => {
            posthog.capture('old_loan_register_failed', {
                step: 'installments',
                status: error?.response?.status,
                fund_id:
                    (variables as any)?.moneyPool ??
                    (state as any)?.payload?.moneyPool,
            })
            toast.error('خطایی پیش آمده!')
        },
    })

    return { mutate }
}
